const FormStatus = {
  AVAILABLEFORDECISION: 'availablefordecision',
  AVAILABLETOIMPLEMENT: 'availabletoimplement',
  BEINGREVISED: 'beingrevised',
  CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED: 'changeisinplacewithconsequentialactionsrequired',
  CLOSED: 'closed',
  CLOSEDREJECTED: 'closedrejected',
  CLOSEDVETOED: 'closedvetoed',
  CLOSEDVOIDED: 'closedvoided',
  DRAFT: 'draft',
  CHANGEISFULLYIMPLEMENTED: 'changeisfullyimplemented',
  NEW: 'new',
  OWNERAPPROVEDDEFERREDSTARTDATE: 'ownerapproveddeferredstartdate',
  PENDINGOWNERDECISION: 'pendingownerdecision',
  SENTBACKFORCORRECTIONS: 'sentbackforcorrections',
  SUBMITTED: 'submitted',
  TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED: 'temporarychangeisinplacewithconsequentialactionsrequired',
  CLOSEDSTRANDED: 'closedstranded',
  properties: {
    availablefordecision: {
      name: 'Available for Decision',
      value: 'availablefordecision'
    },
    availabletoimplement: {
      name: 'Available to Implement',
      value: 'availabletoimplement'
    },
    beingrevised: {
      name: 'Being Revised',
      value: 'beingrevised'
    },
    changeisinplacewithconsequentialactionsrequired: {
      name: 'Change is in place with consequential actions required',
      value: 'changeisinplacewithconsequentialactionsrequired'
    },
    closed: {
      name: 'Closed',
      value: 'closed'
    },
    closedrejected: {
      name: 'Closed Rejected',
      value: 'closedrejected'
    },
    closedvetoed: {
      name: 'Closed Vetoed',
      value: 'closedvetoed'
    },
    closedvoided: {
      name: 'Closed Voided',
      value: 'closedvoided'
    },
    draft: {
      name: 'Draft',
      value: 'draft'
    },
    changeisfullyimplemented: {
      name: 'Change is fully implemented',
      value: 'changeisfullyimplemented'
    },
    new: {
      name: 'New',
      value: 'new'
    },
    ownerapproveddeferredstartdate: {
      name: 'Owner Approved - Deferred Start Date',
      value: 'ownerapproveddeferredstartdate'
    },
    pendingownerdecision: {
      name: 'Pending Owner Decision',
      value: 'pendingownerdecision'
    },
    sentbackforcorrections: {
      name: 'Sent Back for Corrections',
      value: 'sentbackforcorrections'
    },
    submitted: {
      name: 'Submitted',
      value: 'submitted'
    },
    temporarychangeisinplacewithconsequentialactionsrequired: {
      name: 'Temporary change is in place with consequential actions required',
      value: 'temporarychangeisinplacewithconsequentialactionsrequired'
    },
    closedstranded: {
      name: 'Closed Stranded',
      value: 'closedstranded'
    }
  }
}

const Roles = {
  APPROVER: 'approver',
  ADDITIONALAPPROVER: 'additionalApprover',
  ADDITIONALFYI: 'additionalFyi',
  COINITIATOR: 'coinitiator',
  COORDINATOR: 'coordinator',
  FACILITATOR: 'facilitator',
  FACILITATORBACKUP: 'facilitatorBackup',
  FYI: 'fyi',
  INITIATOR: 'initiator',
  OWNER: 'owner',
  LINEMANAGER: 'lineManager',
  SENIORMANAGER: 'vp',
  properties: {
    approver: {
      name: 'Approver',
      value: 'approver'
    },
    additionalApprover: {
      name: 'Additional Approver',
      value: 'additionalApprover'
    },
    additionalFyi: {
      name: 'Additional FYI',
      value: 'additionalFyi'
    },
    coinitiator: {
      name: 'Coinitiator',
      value: 'coinitiator'
    },
    coordinator: {
      name: 'Coordinator',
      value: 'coordinator'
    },
    facilitator: {
      name: 'Facilitator',
      value: 'facilitator'
    },
    facilitatorBackup: {
      name: 'Facilitator Backup',
      value: 'facilitatorBackup'
    },
    fyi: {
      name: 'FYI',
      value: 'fyi'
    },
    initiator: {
      name: 'Initiator',
      value: 'initiator'
    },
    owner: {
      name: 'Owner',
      value: 'owner'
    },
    lineManager: {
      name: 'Line Manager',
      value: 'lineManager'
    },
    vp: {
      name: 'Senior Manager',
      value: 'vp'
    }
  }
}

function debounce(func, wait, immediate) {
  var timeout
  return function () {
    var context = this
    var args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export { FormStatus, Roles, debounce }
